import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';

import {
  CepMaskPipe,
  TelefoneMaskPipe,
  HtmlSanitizerPipe,
  CapitalizeFirstPipe,
  CpfPipe, 
  CpfCnpjPipe
} from './pipes';

import {
  FocusDirective,
  EqualValidator,
  EChartsDirective,
  FontAdjustDirective,
  SlimScrollDirective,
  inputMaskTelefoneDirective,
  inputMaskCpfCnpjDirective,
  inputOnlyNumberDirective,
  inputUppercaseDirective,
  inputMaskDirective,
} from './directives';

import { TranslateModule } from '@ngx-translate/core';
import { TranslateLoader } from '@ngx-translate/core';
import { createTranslateLoader } from '../services/translate.service';
import { HttpClientModule, HttpClient as HttpClient2 } from '@angular/common/http';
import { DialogResultComponent } from './component/dialog-result.component';
import { LoadingComponent } from './component/loading.component';

import { InputNumberComponent } from './component/input-number/input.number.component';
import { MaterialModule } from '@angular/material';
import { SelectModule } from 'ng-select';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    MaterialModule,    
    SelectModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: (createTranslateLoader),
        deps: [HttpClient2]
      }
    })
  ],
  declarations: [
    FocusDirective
    , EqualValidator
    , EChartsDirective
    , HtmlSanitizerPipe
    , CapitalizeFirstPipe
    , FontAdjustDirective
    , SlimScrollDirective
    , CepMaskPipe
    , TelefoneMaskPipe
    , InputNumberComponent
    , inputMaskTelefoneDirective
    , inputMaskCpfCnpjDirective
    , inputOnlyNumberDirective
    , inputUppercaseDirective
    , inputMaskDirective
    , CpfPipe
    , CpfCnpjPipe
  ],
  exports: [
    FocusDirective
    , EqualValidator
    , EChartsDirective
    , HtmlSanitizerPipe
    , CapitalizeFirstPipe
    , FontAdjustDirective
    , SlimScrollDirective
    , CepMaskPipe
    , TelefoneMaskPipe
    , InputNumberComponent
    , inputMaskTelefoneDirective
    , inputMaskCpfCnpjDirective
    , inputOnlyNumberDirective
    , inputUppercaseDirective
    , inputMaskDirective
    , SelectModule
    , CpfPipe
    , CpfCnpjPipe
  ]
})
export class SharedModule { }



// WEBPACK FOOTER //
// C:/Users/anderson.oshiro/Projetos/Azure/Ipcorp.PortalCobranca/Web/Ipcorp.PortalCobranca.Web/src/app/shared/shared.module.ts